export const FRONTEND_STRIPE_KEY = 'pk_live_QUS1ISPRQUHMMKNf8XQKLRVp';
